import { useNavigate } from 'react-router-dom';
import { Auth } from "aws-amplify";
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import  Button  from "../../components/button";
import  Headline4  from "../../components/headings/Headline4";
import AuthHead from "./AuthHead";
import AuthMedia from './authMedia';
import Styles from "./styles.module.scss";
import classnames from "classnames";
import mixpanelData from '../../utils/mixpanel';
import NotificationAlert from '../../components/notification';




export type VerificationFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  password: any;
  vericode: any;
};

export const VerificationForm: FC = () => {
  let query: any = window.location.href
  let urlParams: any = new URL(query);
  let email: any = urlParams.searchParams.get("email")
  
  const {
    handleSubmit,
    // formState: { errors },
  } = useForm<VerificationFormFields>();


  Auth.configure({
    userPoolId: "ap-south-1_xW3Zsub3t",
    userPoolWebClientId: "2jn6qgntppsud848ri333cud5s", // app client id
    region: "ap-south-1",
    oauth: {
      region: "ap-south-1",
      domain: "authmyworkplace.ellow.io",
      scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
      redirectSignIn:"https://myworkplace.ellow.io/login?provider=google",
      redirectSignOut:"https://myworkplace.ellow.io/login" ,
      responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  })
  
  const navigation = useNavigate();

  const onSubmit = (data: any) => {

    navigation('/login', {
      state: email
    })
    mixpanelData('MWP-Verification', {
      'source': "freelancer verified his account",
      'success':  true,
      'distinct_id': email,
      'Email': email,
    })
    mixpanelData('Test-Verification', {
      'source': "freelancer verified his account",
      'success':  true,
      'distinct_id': email,
      'Email': email,
    })
  }


  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <aside className={Styles.loginSignupWapper}>
            <div className={Styles.alignCenter}>
              <Headline4 > Successfully Registered! </Headline4>
              <div className={classnames(Styles.alreadyRegistered, Styles.mt_0, Styles.mb_50)}>Kindly login with the registered email.</div>
              <div className={Styles.loginWith}>
                <form>
                  <Button
                    type="submit" size="large" variant="primary"
                    onClick={handleSubmit(onSubmit)}>
                    Login
                  </Button>
                  <NotificationAlert onClose={(event: any) => navigation('/login')} closable={true} >
                    Successfully Registered
                  </NotificationAlert>
                </form>
              </div>
            </div>
          </aside>
        </div>
        <AuthMedia />
      </div>
    </section>
  );
}

export default VerificationForm;


